import { call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_REGISTRATION_SUCCESS,
  GET_REGISTRATION_FAILED,
  GET_REGISTRATION_REQUESTED,
} from 'resources/actionTypes';
import { RegistrationApi } from 'services/RegistrationService';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function* fetchRegistration(action) {
  const payload = action.payload || {};
  const userRegistration = yield call(RegistrationApi,
    payload.userRegistration?.userDetails
  );
  if (userRegistration?.success) {
    yield put({
      type: GET_REGISTRATION_SUCCESS,
      userRegistration: userRegistration,
    });
    if(payload?.userRegistration?.actionType === ("signup" || "resendOtp")) {
      const userDetails = {
        mobile: payload?.userRegistration?.userDetails?.mobile,
        email: payload?.userRegistration?.userDetails?.email,
        firstName:payload?.userRegistration?.userDetails?.firstName,
        lastName:payload?.userRegistration?.userDetails?.lastName,
        gender:payload?.userRegistration?.userDetails?.gender,
        companyName: payload?.userRegistration?.userDetails?.companyName,
        code: payload?.userRegistration?.userDetails?.countryCode,
        location: payload?.userRegistration?.userDetails?.location,
        secretToken: userRegistration.data[0].otpSecret
      }
      localStorage.setItem('signUpDetails', JSON.stringify(userDetails));
      payload.navigate('/otp?pageType=signupOtp');
    }
    toast.success(userRegistration.message);
  } else {
    yield put({
      type: GET_REGISTRATION_FAILED,
      message: userRegistration.message,
    });
      toast.error(userRegistration.message || 'Registeration failed');
  }
}
function* registrationSaga() {
  yield takeEvery(GET_REGISTRATION_REQUESTED, fetchRegistration);
}

export default registrationSaga;
